import * as XLSX from "xlsx";
import * as h from "./index";

export const getUsersJsonFromList = (
  list: Array<any>,
  company_uid: string | null
) => {
  // função depreciada pode haver lugares utilizando ainda
  let tempUsers = null;

  if (list) {
    if (!company_uid) company_uid = "";
    tempUsers = [];
    if (list[0] && list[0][0].includes("ID_MATRICULA")) list.shift();
    list.forEach((row: Array<any>) => {
      if (row[0]) {
        const registry = row[0] ? row[0] : "";
        const birthdate = row[1] ? row[1] : "";
        const context = row[2] ? row[2] : "";
        tempUsers.push({
          registry,
          birthdate,
          context,
        });
      }
    });
  }
  return tempUsers;
};

export const getUsersJsonFromListUpdated = (
  list: Array<any>,
  company_uid: string | null
) => {
  let tempUsers = null;

  if (list) {
    if (!company_uid) company_uid = "";
    tempUsers = [];
   
    list.forEach((row: Array<any>) => {
      const registry = row;
      const birthdate = null;
      const context = "";
      tempUsers.push({
        registry,
        birthdate,
        context,
      });
    });
  }

  return tempUsers;
};

export const getUsersJsonPermission = () => {
  const relat = new URL(window.location.href);
  let caixa = [] as Array<any>;
  caixa = relat.pathname.split("/").reverse();
  let visto: string | null = null;
  if (caixa[0] === "go") {
    visto = "01";
  } else {
    visto = "10";
  }
  return visto;
};

export const createTempModel = (
  fnGetPermission: string | null,
  fnGetUsersJsonFromList: Array<any> | null
) => {
  const model = [
    {
      permission: fnGetPermission,
      users: fnGetUsersJsonFromList,
    },
  ];

  return model;
};

export const xlsxToObject = (
  files: any,
  setError: (v: string) => void,
  setLoading: (v: boolean) => void,
  setUsers: (v: any) => void
) => {
  setLoading(true);
  try {
    const f = files[0];
    if (f) {
      const isExcelFile = f.name.split(".");
      if (h.isSameText(isExcelFile[isExcelFile.length - 1], "xlsx")) {
        const reader = new FileReader();
        reader.onload = function (e: any) {
          const data = e.target.result;
          const readData = XLSX.read(data, {
            type: "binary",
            raw: true,
          });
          const wsName = readData.SheetNames[0];
          const ws = readData.Sheets[wsName];
          const dataParse = XLSX.utils.sheet_to_json(ws, {
            header: 1,
            raw: false,
          });
          setUsers(dataParse);
        };
        reader.readAsBinaryString(f);
      } else {
        setError("wrong_file");
      }
    } else {
      setError("file_not_loaded");
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
  }
};
